import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

import { TrainingModeBannerComponent } from './training-mode-banner.component';

@NgModule({
  declarations: [TrainingModeBannerComponent],
  imports: [CommonModule, TranslocoModule],
  exports: [TrainingModeBannerComponent]
})
export class TrainingModeBannerComponentModule {}
